// ControleDashboardPage.jsx
import { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner
} from "react-bootstrap";
import { useWebProvider } from "../../hooks/defaults/useWebProvider";
import { endPointCaderno } from "../../models/constantes";

import GlobalResumoCard from "../../Components/processo/GlobalProcessoDashboardCard";
import PlanoDeControleDashboard from "../../Components/processo/PlanoControleDashboard";
import { fromLocalInputValue, toLocalInputValue } from "../../Services/processo/dashboardProcessoUtils";
import YearMonthsSelector from "../../Components/default-components/forms/YearMonthsSelector";
import dayjs from "dayjs";



export default function ProcessoDashboard() {
  // filtros de período
  const [start, setStart] = useState(dayjs().subtract(30, 'days').startOf('day').format("YYYY-MM-DDTHH:mm:ss"));
  const [end, setEnd] = useState(dayjs().endOf('day').format("YYYY-MM-DDTHH:mm:ss"));
  const [useCustomRange, setUseCustomRange] = useState(true);

  // estado de dados / UI
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const { controller } = useWebProvider();

  const buildUrl = (s, e) =>
    `/buildControleDashboard/${encodeURIComponent(s)}/${encodeURIComponent(e)}`;

  const fetchData = async (s, e) => {
    // Only fetch if dates are valid
    if (!s || !e) return;
    
    setLoading(true);
    setErr(null);
    try {
      const res = await controller(null, endPointCaderno).get(
        buildUrl(s, e)
      );
      const json = await res;
      setData(json || {});
    } catch (error) {
      setErr(error?.message || "Erro ao carregar dados");
      setData({});
    } finally {
      setLoading(false);
    }
  };

  // carrega automaticamente com o range default (apenas no mount)
  useEffect(() => {
    fetchData(start, end);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // normaliza chaves com possíveis grafias antigas
  const estatisticasGlobais =
    data?.estatisticas || {};
  const estatisticasDeFrequenciaGlobais = data?.analiseFrequencia || {}

  const handleYearMonthSelect = ({ dataInicio, dataFim }) => {
    if (dataInicio && dataFim) {
      setStart(dataInicio);
      setEnd(dataFim);
      // Optional: Auto fetch on select? Or wait for button?
      // Since button is explicit, we just update state.
    }
  };

  return (
    <Container fluid className="py-3">
      {/* Filtros de período */}
      <Card className="mb-4">
        <Card.Body>
          <Row className="g-3 align-items-end">
            <Col xs={12}>
               <div className="d-flex justify-content-between align-items-center mb-2">
                 <h6 className="mb-0 text-muted">Período de Análise</h6>
                 <Form.Check 
                   type="switch"
                   id="custom-range-switch"
                   label="Intervalo personalizado"
                   checked={useCustomRange}
                   onChange={(e) => setUseCustomRange(e.target.checked)}
                 />
               </div>
            </Col>
            
            {!useCustomRange ? (
              <Col xs={12}>
                <YearMonthsSelector 
                  dataInicio={start} 
                  dataFim={end}
                  onSelect={handleYearMonthSelect}
                />
              </Col>
            ) : (
                <>
                  <Col md={3}>
                    <Form.Label>Início</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={toLocalInputValue(start)}
                      onChange={(e) => setStart(fromLocalInputValue(e.target.value))}
                    />
                  </Col>
                  <Col md={3}>
                    <Form.Label>Fim</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={toLocalInputValue(end)}
                      onChange={(e) => setEnd(fromLocalInputValue(e.target.value))}
                    />
                  </Col>
                </>
            )}

            <Col md="auto" className="ms-auto">
              <Button
                variant="primary"
                onClick={() => fetchData(start, end)}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      animation="border"
                      size="sm"
                      className="me-2"
                      role="status"
                    />
                    Carregando…
                  </>
                ) : (
                  "Carregar"
                )}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Erros */}
      {err && (
        <Alert variant="danger" className="mt-3">
          <strong>Erro:</strong> {err}
        </Alert>
      )}

      {/* Header global (apenas estatística) */}
      {!loading && !err && data?.planosDashboards?.length > 0 && (
        <GlobalResumoCard estatisticasGlobais={estatisticasGlobais} estatisticasDeFrequencia={estatisticasDeFrequenciaGlobais} />
      )}

      {/* Vazio */}
      {!loading &&
        !err &&
        (!data?.planosDashboards || data.planosDashboards.length === 0) && (
          <Card className="mt-3">
            <Card.Body>Nenhum dado para o intervalo informado.</Card.Body>
          </Card>
        )}

      {/* Dashboard por plano/controle */}
      {!loading && !err && data?.planosDashboards?.length > 0 && (
        <PlanoDeControleDashboard data={data} />
      )}
    </Container>
  );
}





